import { Directive, ElementRef, HostListener } from '@angular/core';

const FOCUSABLE_SELECTOR = 'input, select, textarea, button, [tabindex]';

@Directive({
  selector: '[appEnterAsTab]',
  standalone: true
})
export class EnterAsTabDirective {
  constructor(private el: ElementRef<HTMLElement>) { }

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent) {
    event.preventDefault();

    const container = this.el.nativeElement.closest('form') ?? document.body;
    const candidates = Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR))
      .filter(elem =>
        !(elem as HTMLInputElement | HTMLButtonElement | HTMLSelectElement).disabled &&
        elem.tabIndex !== -1 &&
        elem.offsetParent !== null
      );

    const currentIndex = candidates.indexOf(this.el.nativeElement);
    if (currentIndex > -1 && currentIndex < candidates.length - 1) {
      candidates[currentIndex + 1].focus();
    }
  }
}
